// extracted by mini-css-extract-plugin
export default {"answerButton":"answer-button_answerButton__tUsfl"};